import _slicedToArray from "/app/node_modules/.pnpm/@babel+runtime@7.26.0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import r, { useState as u } from "react";
function f(_ref) {
  var o = _ref.children,
    e = _ref.freeze;
  var n = l(e, o);
  return r.createElement(r.Fragment, null, n);
}
function l(o, e) {
  var _u = u(e),
    _u2 = _slicedToArray(_u, 2),
    n = _u2[0],
    t = _u2[1];
  return !o && n !== e && t(e), o ? n : e;
}
export { f as Frozen, l as useFrozenData };